enum EnumReferralTrackingStatus {
  Pending = 0,
  Completed = 1,
  Cancelled = 2,
}

export default EnumReferralTrackingStatus;
